import React from 'react'
import './sectionTeam.css';

function SectionTeam() {
  return (
    <section className='sectionTeam'>
        
        <div className='container sectionTeam_main'>

            <h1 className='sectionTeam_title'>Supported by Industry Leaders</h1>
            
            
          <div className='sectionTeam_content_wrapper'>
            <div className='sectionTeam_content'>
                <div className='sectionTeam_content1'>Sandeep Nailwal</div>
                <div className='sectionTeam_content2'>Polygon</div>
                </div>
            <div className='sectionTeam_content'>
                <div className='sectionTeam_content1'>Bobbin Threadbare</div>
                <div className='sectionTeam_content2'>Miden</div>
                </div>
            <div className='sectionTeam_content'>
                <div className='sectionTeam_content1'>Jordi Baylina</div>
                <div className='sectionTeam_content2'>ZisK</div>
                </div>
            <div className='sectionTeam_content'>
                <div className='sectionTeam_content1'>Daniel Lubarov</div>
                <div className='sectionTeam_content2'>Polygon</div>
                </div>
          </div>

        </div>
    </section>
  )
}

export default SectionTeam